import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddVehicleTypeModal = ({ isAddOpen, onAddClose, formData, setFormData, id, sa }) => {
  if (!isAddOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "sa") {
      const parsedValue = JSON.parse(value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: parsedValue,
      }));
    } else if (name === "qty") {
      const numericValue = value.replace(/[^0-9.]/g, "");
      setFormData((prevData) => ({
        ...prevData,
        [name]: numericValue,
      }));
    } else if (name === "usage") {
      const digitsOnly = value.replace(/\D/g, "");
      setFormData((prevData) => ({
        ...prevData,
        [name]: digitsOnly,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    if (!formData.sa || !formData.sa.subid) {
      Swal.fire("Validation Error", "Please select a Sub Assembly.", "warning");
      return false;
    }
    if (!formData.desc || formData.desc.trim() === "") {
      Swal.fire("Validation Error", "Description is required.", "warning");
      return false;
    }
    if (!formData.partNo || formData.partNo.trim() === "") {
      Swal.fire("Validation Error", "Part Number is required.", "warning");
      return false;
    }
    if (!formData.spec || formData.spec.trim() === "") {
      Swal.fire("Validation Error", "Specification is required.", "warning");
      return false;
    }
if (!formData.qty || formData.qty.trim() === "") {
  Swal.fire("Validation Error", "Quantity is required.", "warning");
  return false;
}

    if (!formData.usage || isNaN(formData.usage) || Number(formData.usage) < 0) {
      Swal.fire("Validation Error", "Usage must be a non-negative number.", "warning");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    console.log("Form Submit Triggered");
    console.log("Form Data:", formData);

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const payload = {
        id: id,
        sa: formData.sa,
        desc: formData.desc,
        partNo: formData.partNo,
        spec: formData.spec,
        qty: formData.qty,
        usage: formData.usage,
      };

      console.log("Payload being sent to server:", payload);
      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/add_veh_type_main`, payload);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Sub Assembly inserted successfully.",
        });
        onAddClose();
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
    } catch (error) {
      console.error("Error inserting:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Insert failed. Please try again.",
      });
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <button className="close-btn" onClick={onAddClose} style={{ position: "initial" }}>
            &times;
          </button>
        </div>
        <h3>Add Vehicle Maintenance Entry</h3>
        <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Sub Assembly :</label>
              <select
                name="sa"
                value={formData.sa ? JSON.stringify(formData.sa) : ""}
                onChange={handleChange}
                required
              >
                <option value="">-Select-</option>
                {sa.map((item, index) => (
                  <option
                    key={index}
                    value={JSON.stringify({
                      subid: item.fld_subid,
                      subassembly: item.fld_subassembly,
                    })}
                  >
                    {item.fld_subassembly}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {["desc", "partNo", "spec", "qty", "usage"].map((field, idx) => (
            <div className="form-row" key={idx}>
              <div className="form-group">
                <label>{field.charAt(0).toUpperCase() + field.slice(1)} :</label>
                <input
                  type={field === "qty" || field === "usage" ? "number" : "text"}
                  name={field}
                  min="0"
                  value={formData[field]}
                  onChange={handleChange}
                />
              </div>
            </div>
          ))}

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddVehicleTypeModal;
